export const stripeElementsClasses = {
    base: 'stripe-element',
    complete: 'stripe-element--complete',
    empty: 'stripe-element--empty',
    focus: 'stripe-element--focus',
    invalid: 'stripe-element--invalid',
};

export const stripeElementsStyle = {
    base: {
        color: '#000',
        fontFamily: 'Helvetica',
        fontSize: '20px',
        fontSmoothing: 'antialiased',
        fontWeight: '200',
        lineHeight: '32.5px',
        '::placeholder': {
            fontFamily: 'Helvetica',
            fontSize: '20px',
            fontWeight: '200',
            fontStyle: 'italic',
        },
    },
    invalid: {
        color: '#000',
    },
};

export const stripeElementsFonts = {
    family: 'Helvetica',
    style: 'normal',
    weight: '200',
};

export const AMEX_CARD_BRAND = 'American Express';
